import React from 'react';
import { Header, Segment, Button, Icon, Message, Dimmer, Loader } from 'semantic-ui-react';

/**
 * Reusable header component for management pages
 * @param {Object} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const ManagementHeader = ({
  title,
  error,
  isLoading,
  width = '100%',
  children,
  isEditing = false,
  navigateToComponent,
  setPersistSelections,
  onNavigate
}) => {
  return (
    <div style={{ maxWidth: width }}>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <Header as="h2" style={{ margin: 0 }}>
            {title}
          </Header>

          {/* Navigation button to next component (e.g., from Character to Variation) */}
          {/* {isEditing && navigateToComponent && (
            <Button
              primary
              icon
              labelPosition="right"
              onClick={() => {
                // Ensure selections persist when navigating
                if (setPersistSelections) {
                  setPersistSelections(true);
                }

                // Use the navigation function if provided
                if (onNavigate && navigateToComponent.tabIndex !== undefined) {
                  console.log('ManagementHeader: Navigating to tab', navigateToComponent.tabIndex);
                  onNavigate(navigateToComponent.tabIndex);
                } else {
                  console.warn('ManagementHeader: No navigation function provided or tab index is undefined');

                  // Fallback to DOM manipulation if onNavigate is not provided
                  const tabsElement = document.querySelector('.ui.tab.segment');
                  if (tabsElement) {
                    const tabMenu = tabsElement.parentElement.querySelector('.ui.menu');
                    if (tabMenu) {
                      const tabItems = tabMenu.querySelectorAll('.item');
                      if (tabItems && tabItems.length > navigateToComponent.tabIndex) {
                        tabItems[navigateToComponent.tabIndex].click();
                      }
                    }
                  }
                }
              }}
            >
              Go to {navigateToComponent.entityName}
              <Icon name={navigateToComponent.icon} />
            </Button>
          )} */}
        </div>

        {/* Error message */}
        {error && (
          <Message negative>
            <Message.Header>Error</Message.Header>
            <p>
              {typeof error === 'string'
                ? error
                : error.message
                  ? error.message
                  : error.error
                    ? error.error
                    : 'An error occurred. Please try again.'}
            </p>
          </Message>
        )}

        {/* Loading state */}
        {isLoading ? (
          <Dimmer active inverted>
            <Loader inverted>Loading</Loader>
          </Dimmer>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default ManagementHeader;
